import { z } from 'zod';
import { LABEL_COLORS } from '../enums.js';
import { nonEmptyString } from './common.js';
export const MAX_LABELS_PER_CASE = 20;
export const labelNameSchema = nonEmptyString(40, 'Label');
export const createLabelSchema = z.object({
    name: labelNameSchema,
    color: z.enum(LABEL_COLORS).default('gray'),
});
export const updateLabelSchema = z
    .object({
    name: labelNameSchema.optional(),
    color: z.enum(LABEL_COLORS).optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Nothing to update' });
//# sourceMappingURL=label.js.map